// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap__-774tk0prJU5s","top":"top__qvqWHb8ddFeaU","icon":"icon__xLle3-+Qk+Uxt","label":"label__IiV-ZMMq98WXp","head":"head__iGnmBqYmnx+kz","subHead":"subHead__PBkuM-MWvCjKs"};